interface Props {
  modalName: string;
}
export const useStoreModalValue = <TInitValues extends object>({
  modalName,
}: Props) => {
  const localStorageFormKey = `device-troubleshoot_${modalName}`;
  const storedData = localStorage.getItem(localStorageFormKey);
  const parsedData: TInitValues | null = storedData
    ? JSON.parse(storedData)
    : null;

  const setModalValuesToStorage = (values: TInitValues) => {
    localStorage.setItem(localStorageFormKey, JSON.stringify(values));
  };

  return {
    parsedData,
    setModalValuesToStorage,
  };
};
